<h1>Úprava údajů ZP</h1>

<p class="text-center info pb-20 pt-20 pr-15">
  Došlo k úpravě údajů o ZP (číslo ZP / datum vyhotovení / znalec). Je-li nutné aktualizovat i sken dokumentu ZP, vložte nový do dialogu níže. Původní sken dokumentu ZP bude zneplatněn.
</p>

<ng-container>
  <fileupload (change)="onFileChange($event)" [message]="filesMsg" inputId="opinionNewAttachmentsHidden"></fileupload>
</ng-container>

<div class="text-center">
  <gmt-button [clickAction]="onUpdate" [gmtDisabled]="!filesValid" class="pr-15">Nahrát</gmt-button>
  <gmt-button [clickAction]="onCancel" class="red">Nenahrávat</gmt-button>
</div>
